export enum FeatureFlag {
    PurchaseOrders = 'SHOW_EXTRANET_PURCHASE_ORDERS',
    MicrosoftLogin = 'MICROSOFT_LOGIN',
    BonusSettlements = 'BONUS_SETTLEMENTS',
}
